import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import DossiersList from '../../../components/dashboard/dossiersList/DossiersList'
import dossiersListActions from '../../../actions/dashboard/dossiersList/dossiersList'
import { translate } from 'react-polyglot'
import TrackingContainer from '../../../containers/tracking/trackingContainer'
// import { push, goBack } from 'react-router-redux'

export function mapStateToProps (state) {
  return {
    ...state.dashboardDossiersList,
    organizedUnit: state.auth.organizedUnit
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      ...dossiersListActions/* ,
      navigateTo: push,
      goBack */
    }, dispatch)
  }
}

var decoratedComponent = TrackingContainer(DossiersList)
export default connect(mapStateToProps, mapDispatchToProps)(translate()(decoratedComponent))
